import { getDropdownItemsFromStatusConfig } from 'shared/ui/Status'
import { type IDropdownItem } from 'shared/ui'
import {
  rcsSetStatusConfig,
  rcsSettableStatusConfig,
} from 'entities/Compliance/ui/RcsStatus/config'

export const rcsSettableStatusesDropdownItems =
  getDropdownItemsFromStatusConfig(rcsSettableStatusConfig)

export const rcsSetStatusOptions: IDropdownItem[] = Object.entries(rcsSetStatusConfig).map(
  ([id, item]) => ({ id, label: item.title })
)
